<template>
	<UserForm :gift="gift" :configuration="configuration"></UserForm>
</template>

<script>
	import UserForm from '../UserForm.vue';

	export default {
		components: {UserForm},
		props: {
			entry: Object,
            configuration: Object,
			gift: Object
		}
	}
</script>